import Component from 'antd/es/modal';
import 'antd/lib/modal/style';
export default Component;
